var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-5"},[_c('strong',{staticClass:"d-block",domProps:{"innerHTML":_vm._s(_vm.offer.info.modelName)}}),_vm._v(" "),_c('strong',{staticClass:"d-block"},[_vm._v(_vm._s(_vm.$t('date'))+": "+_vm._s(_vm._f("dateFormat")(_vm.searchRequest.pickUpDateTime)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }